"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotStackOfCoins = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotStackOfCoins = _ref => {
  let {
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M23.565 13.672c3.62.547 7.95 3.438 9.43 7.807 1.469 4.37.076 10.208-3.544 13.906-3.62 3.697-9.459 5.252-14.423 4.378-4.975-.864-9.065-4.167-11.85-7.864C.393 28.2-1.086 24.11.94 22.035c2.027-2.074 7.558-2.112 10.343-2.66 2.784-.547 2.823-1.584 4.292-3.015 1.479-1.421 4.37-3.236 7.99-2.689Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    d: "M25 10.345c0 2.4-4.03 4.345-9 4.345s-9-1.946-9-4.345m18 0C25 7.945 20.97 6 16 6s-9 1.945-9 4.345m18 0v4.827c0 .56-.218 1.093-.617 1.584M7 10.345v4.827m0 0c0 2.4 4.03 4.345 9 4.345 1.488 0 2.891-.174 4.127-.482a12.453 12.453 0 0 0 1.64-.526M7 15.172V20m0 0c0 2.4 4.03 4.345 9 4.345 1.069 0 2.094-.09 3.046-.255M7 20v4.828m0 0c0 2.4 4.03 4.344 9 4.344 1.366 0 2.662-.147 3.822-.41M7 24.828v4.827C7 32.055 11.03 34 16 34c2.555 0 4.862-.514 6.5-1.34l.325-.296M28.273 19v2.181m0 9.819v-2.182M31 21.18h-2.727M25 28.819h3.273m-3.89-12.062A9 9 0 1 1 28 34a8.958 8.958 0 0 1-5.175-1.636m1.558-15.608a9.016 9.016 0 0 0-2.617 1.753m0 0a8.975 8.975 0 0 0-2.72 5.58m0 0a8.965 8.965 0 0 0 .776 4.673m0 0a9.036 9.036 0 0 0 3.003 3.602m5.448-11.182h-1.364a1.91 1.91 0 0 0 0 3.818H29.636a1.909 1.909 0 1 1 0 3.818h-1.363"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotStackOfCoins = SpotStackOfCoins;
SpotStackOfCoins.displayName = "SpotStackOfCoins";